<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { beatInfoCollection, sampleInfoCollection } from "../samples"; 
  import type { BeatInfo, SampleInfo } from "../samples";  

  import { beatInfo, sampleInfo } from './../stores';
    
  import { Card, CardText, CardActions, Col, Row, Button, Icon, Overlay, Select } from 'svelte-materialify/src';
  import { mdiMusicNote } from '@mdi/js';

  const dispatch = createEventDispatcher(); 

  let currentBeatId = $beatInfo.id;
  let currentSampleId = $sampleInfo.id;

  let showSampleSelect: boolean = false;
  const closeSampleSelect = () => {
    showSampleSelect = false;
  }

  const beatItems = Array.from(beatInfoCollection.values()).map((beatInfo: BeatInfo) => {
    return { name: beatInfo.name, value: beatInfo.id };
  });

  const sampleItems = Array.from(sampleInfoCollection.values()).map((sampleInfo: SampleInfo) => {
    return { name: sampleInfo.name, value: sampleInfo.id };
  });

  const onSampleSelection = (ev: CustomEvent) => {
    const sampleId = ev.detail;
    dispatch('selectsample', sampleId);
  };

</script>


<Button icon title="Change beat/sample"
  on:click={() => { showSampleSelect = true; }}>
  <Icon path={mdiMusicNote} />
</Button>

<Overlay active={showSampleSelect} on:click={closeSampleSelect}>
  <div on:click|stopPropagation>
  <Card outlined class="text-left">
    <div class="pl-4 pr-4 pt-3">
      <span class="text-h5 mb-2">Audio selection</span>
      <br />
    </div>
    <CardText>
      
      <Row>
        <Col>
          <Select items={beatItems} bind:value={currentBeatId} disabled>
            Beat
          </Select>
        </Col>
      </Row>

      <Row>
        <Col>
          <Select items={sampleItems} bind:value={currentSampleId} on:change={onSampleSelection}>
            Skratch sample
          </Select>
        </Col>
      </Row>

      <Row>
        <Col>
          Big thanks to <a href="http://zuckell.com/" target="_blank" title="">Zuckell</a> for providing awesome beats! Check out his page for more info: <a href="http://zuckell.com/" target="_blank" title="">zuckell.com</a>.
        </Col>
      </Row>

    </CardText>
    <CardActions>
      <Button rounded outlined  on:click={closeSampleSelect}>Done</Button>
    </CardActions>
  </Card>
  </div>
</Overlay>
